import { Button, Heading, Icon, Shadow, Text, HStack, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React, { useCallback, useMemo } from 'react';

import { LateralBar } from '../../../../../../../../../../../../components/LateralBar';
import { PrivatePensionAssetController } from '../../../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/PrivatePension';

import { PortabilityItem } from './components/PortabilityItem';

export namespace PortabilityCardTypes {
  export interface Props {
    offerController: PrivatePensionAssetController;
    onEdit: (index: number) => void;
    onAdd: () => void;
  }
}

export const PortabilityCard: React.FC<PortabilityCardTypes.Props> = ({
  offerController,
  onEdit,
  onAdd,
}) => {
  const { portabilities, portabilityAmount } = offerController;

  const handleRemovePortability = useCallback(
    (index: number) => {
      offerController.removePortability(index);
    },
    [offerController]
  );

  const portabilityList = useMemo(() => {
    return portabilities.map((portability, index) => {
      return (
        <PortabilityItem
          key={index}
          index={index}
          portability={portability}
          offerController={offerController}
          onEdit={onEdit}
          onRemove={handleRemovePortability}
        />
      );
    });
  }, [handleRemovePortability, onEdit, portabilities, offerController]);

  return (
    <Shadow level={1} borderRadius="sm">
      <LateralBar barColor="product.previdencia" />
      <VStack padding="inset.sm" space="stack.xxs">
        <Heading size="h3" testId="portability">
          Portabilidade
        </Heading>
        {portabilities.length === 0 ? (
          <Text>Inclua uma ou mais portabilidades na previdência. </Text>
        ) : (
          <VStack space="stack.nano">{portabilityList}</VStack>
        )}
        <HStack justifyContent="space-between">
          <Text>Valor das portabilidades: </Text>
          <Text variant="semibold">{Utils.Mask.Money(portabilityAmount)}</Text>
        </HStack>
        <Button
          variant="textLink"
          leftIcon={<Icon name="Plus" size="sm" color="brand.tertiary.principal" />}
          alignSelf="flex-start"
          onPress={onAdd}>
          Incluir Portabilidade
        </Button>
      </VStack>
    </Shadow>
  );
};
